export default __webpack_public_path__ + "static/media/ps_modal_wire_black.e892f093.svg";